import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { call } from '@hlt/web-kit/api';
import { prefetch } from '@/app/prefetch';
import { publicIdParam, resolveResource } from '@/app/route-ids';
import { isEditorStep, type EditorStep } from '@/features/templates/editor/editor-steps';
import { TemplateEditorPage } from '@/features/templates/editor/template-editor-page';

export const Route = createFileRoute('/_app/w/$workspaceId/templates/$templateId')({
    params: publicIdParam('templateId'),
    staticData: {
        crumbs: [{ label: 'shell.templates', to: '/w/$workspaceId/templates' }, { label: 'shell.crumbTemplate' }],
    },
    // `step` keeps the open editor step across reloads.
    validateSearch: (search: Record<string, unknown>): { step?: EditorStep } =>
        isEditorStep(search.step) ? { step: search.step } : {},
    beforeLoad: async ({ context, params, location }) =>
        await resolveResource({
            ref: params.templateId,
            collection: 'templates',
            location,
            read: async () =>
                await call('getTemplate', { params: { ...context.workspaceScope, templateId: params.templateId } }),
        }),
    loader: ({ context, params }) => prefetch.template(context.queryClient, context.workspaceScope, params.templateId),
    component: function TemplateEditorRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        const { templateId } = Route.useParams();
        const { step } = Route.useSearch();
        const navigate = useNavigate({ from: Route.fullPath });
        return (
            <TemplateEditorPage
                key={templateId}
                organizationId={organizationId}
                workspaceId={workspaceId}
                templateId={templateId}
                step={step ?? 'areas'}
                onStep={(next) => void navigate({ search: { step: next }, replace: true })}
            />
        );
    },
});
